module.exports = __webpack_public_path__ + "img/icon_instagram_link.4ea61aa3.svg";